<ng-container>
	<ng-container *ngIf="desktop; else mobile">
		<label
			class="obg-m-annual-validation-notification-label"
			test-id="annual-validation-notification-label"
			data-test-id="annual-validation-notification-label"
			[innerHTML]="label | translate: { activeFromDate: activeFromDate }"
		></label>

		<a
			*ngIf="!isProcessing"
			class="obg-m-annual-validation-notification-button"
			test-id="annual-validation-notification-button"
			data-test-id="annual-validation-notification-button"
			(click)="onVerify()"
		>
			{{ button | translate }}
		</a>
		<i
			*ngIf="!expired || isProcessing"
			class="obg-m-annual-validation-notification-icon ico-close"
			test-id="annual-validation-notification"
			data-test-id="annual-validation-notification"
			(click)="dismissNotification.emit()"
		></i>
	</ng-container>

	<ng-template #mobile>
		<div class="obg-m-annual-validation-notification-label-container">
			<label
				class="obg-m-annual-validation-notification-label"
				test-id="annual-validation-notification-label"
				data-test-id="annual-validation-notification-label"
				[innerHTML]="label | translate: { activeFromDate: activeFromDate }"
			></label>
			<i
				*ngIf="!expired || isProcessing"
				class="obg-m-annual-validation-notification-icon ico-close"
				test-id="annual-validation-notification"
				data-test-id="annual-validation-notification"
				(click)="dismissNotification.emit()"
			></i>
		</div>

		<a
			*ngIf="!isProcessing"
			class="obg-m-annual-validation-notification-button"
			test-id="annual-validation-notification-button"
			data-test-id="annual-validation-notification-button"
			(click)="onVerify()"
		>
			{{ button | translate }}
		</a>
	</ng-template>
</ng-container>
